
import Calendar1 from "../../../assets/duotone/Calendar1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Calendar1Icon({ className, dataTestid = "Calendar1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Calendar1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
